<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header">
      <i class="el-icon-date"></i>
      <span class="title">权限维护</span>
    </div>
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 90%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="工号"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="userNickName"
          label="姓名"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="查看部门范围"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="badgeRecord"
          label="是否查看徽章记录"
          align="center"
          min-width="120"
        >
          <template slot-scope="{ row }">
            <div>{{ row.badgeRecord ? "是" : "否" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="medalRecord"
          label="是否查看提报记录"
          align="center"
          min-width="120"
        >
          <template slot-scope="{ row }">
            <div>{{ row.medalRecord ? "是" : "否" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="administrators"
          label="是否是管理员"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <div>{{ row.administrators ? "是" : "否" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateUserName"
          label="更新人"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="更新时间"
          align="center"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`${title}`"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          label-width="120px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="姓名" prop="userNickName">
                <el-cascader
                  ref="usernameList"
                  v-model="form.userNickName"
                  :options="treeList"
                  :props="defaultProps"
                  clearable
                  filterable
                  size="mini"
                  :show-all-levels="false"
                  @change="handleUsername"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="是否管理员"
                prop="administrators"
                label-width="130px"
              >
                <!--   @change="changeAdministrators" -->
                <el-select
                  @change="chandleChange2"
                  v-model="form.administrators"
                  placeholder="请选择是否管理员"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsType2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="工号">
                <el-input
                  v-model="form.userName"
                  placeholder="请输入工号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="是否查看徽章记录"
                prop="badgeRecord"
                label-width="130px"
              >
                <el-select
                  v-model="form.badgeRecord"
                  placeholder="请选择是否查看徽章记录"
                  style="width: 100%"
                  :disabled="form.administrators == 1"
                >
                  <el-option
                    v-for="item in optionsType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="查看部门范围" prop="departmentCode">
                <el-cascader
                  v-model="form.departmentCode"
                  style="width: 100%"
                  :options="treeList1"
                  :props="defaultProps1"
                  clearable
                  collapse-tags
                  filterable
                  :disabled="form.administrators == 1"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="是否查看提报记录"
                prop="medalRecord"
                label-width="130px"
              >
                <el-select
                  v-model="form.medalRecord"
                  placeholder="请选择是否查看提报记录"
                  style="width: 100%"
                  :disabled="form.administrators == 1"
                >
                  <el-option
                    v-for="item in optionsType1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          class="add"
          @click="confirmSubmit"
          :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button
          class="add"
          @click="confirmDetele"
          :disabled="isBtnDisabled"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "badgeCategory",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        badgeRecord: 1,
        medalRecord: 1,
        administrators: 1,
        departmentCode: []
      },
      rules: {
        userNickName: [
          {
            required: true,
            message: "请选择姓名",
            trigger: "change"
          }
        ],
        departmentCode: [
          {
            required: true,
            message: "请选择查看部门范围",
            trigger: "change"
          }
        ]
      },
      title: "新增",
      deleteVisible: false,
      itemId: "",
      optionsType: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      optionsType1: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      optionsType2: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      treeList: [],
      defaultProps: {
        children: "child",
        // checkStrictly: true,
        value: "username",
        label: "nickname",
        emitPath: false
        // expandTrigger: "hover"
      },
      treeList1: [],
      defaultProps1: {
        multiple: true,
        children: "child",
        value: "departmentCode",
        label: "departmentName",
        emitPath: false
      },
      treeList2: [],
      isBtnDisabled: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.querydirectory();
    this.querydirectory1();
  },
  //销毁
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },

    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页器改变每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 分页器改变当前页数
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        nickname: "",
        userName: "",
        userNickName: "",
        department: "",
        medalRecord: 1,
        badgeRecord: 1,
        administrators: 1,
        departmentCode: []
      };
      this.$refs.ruleForm.resetFields();
      this.itemId = "";
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form.departmentCode = this.treeList2;
      this.dialogVisible = true;
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form.userName = this.multipleSelection[0].userName;
        this.form.userNickName = this.multipleSelection[0].userName;
        this.form.nickname = this.multipleSelection[0].userNickName;
        this.form.department = this.multipleSelection[0].deptName;
        this.form.badgeRecord = this.multipleSelection[0].badgeRecord ? 1 : 0;
        this.form.medalRecord = this.multipleSelection[0].medalRecord ? 1 : 0;
        this.form.administrators = this.multipleSelection[0].administrators
          ? 1
          : 0;
        this.form.departmentCode =
          this.multipleSelection[0].departmentCode?.split(",");
        this.itemId = this.multipleSelection[0].id;
        this.title = "编辑";
        this.dialogVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行编辑",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的内容",
          type: "warning"
        });
      }
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const json = {
            userName: this.form.userName,
            userNickName: this.form.nickname,
            badgeRecord: this.form.badgeRecord,
            medalRecord: this.form.medalRecord,
            administrators: this.form.administrators,
            departmentCode: this.form.departmentCode.toString()
          };
          if (this.title == "编辑") {
            json.id = this.multipleSelection[0].id;
          }
          this.isBtnDisabled = true;
          api
            .addOrUpdateMedalUserPermission(json)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  message: this.title + "成功",
                  type: "success"
                });
                this.itemId = "";
                this.dialogVisible = false;
                this.isBtnDisabled = false;
                this.form = {
                  nickname: "",
                  userName: "",
                  userNickName: "",
                  department: "",
                  medalRecord: 1,
                  badgeRecord: 1,
                  administrators: 1,
                  departmentCode: this.treeList2
                };
                this.$refs.ruleForm.resetFields();
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      console.log(this.multipleSelection);

      if (this.multipleSelection.length == 1) {
        this.deleteVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行删除",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要删除的内容",
          type: "warning"
        });
      }
    },
    //确认删除
    confirmDetele() {
      this.isBtnDisabled = true;
      api
        .deleteMedalUserPermission({ id: this.multipleSelection[0].id })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });

            this.deleteVisible = false;
            this.isBtnDisabled = false;
            this.queryData();
          }
        })
        .catch(() => {
          this.isBtnDisabled = false;
        });
    },
    // 查询 列表
    queryData() {
      this.tableLoading = true;
      api
        .queryMedalUserPermission({ ...this.pageData })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 获取姓名
    querydirectory() {
      api.directory().then(data => {
        if (data.code == 200) {
          this.treeList = data.data;
        }
      });
    },
    //获取活动范围
    querydirectory1() {
      api.findListByName().then(data => {
        if (data.code == 200) {
          this.treeList1 = data.data;
          this.treeList2 = this.filterDepartmentCode(data.data);
        }
      });
    },
    // 过滤底层所有部门
    filterDepartmentCode(data) {
      let ids = [];
      for (let item of data) {
        if (!item.child || item.child.length === 0) {
          ids.push(item.departmentCode);
        } else {
          ids = ids.concat(this.filterDepartmentCode(item.child));
        }
      }

      return ids;
    },
    //获取用户信息
    handleUsername(val) {
      this.$set(this.form, this.form.userNickName, val);
      api
        .queryByUsername({
          username: this.form.userNickName
        })
        .then(res => {
          if (res.code == 200) {
            if (this.form.userNickName) {
              this.form.nickname = res.data.nickname;
              this.form.userName = res.data.username;
              this.form.department = res.data.department;
            } else {
              this.form.nickname = "";
              this.form.userName = "";
              this.form.department = "";
            }
            this.$forceUpdate();
          }
        });
    },

  //  选择是否管理员
    chandleChange2(val) {
      // this.$forceUpdate();
      this.form.departmentCode = val == 1 ? this.treeList2 : [];
      this.form.medalRecord = val == 1 ? 1 : this.form.medalRecord;
      this.form.badgeRecord = val == 1 ? 1 : this.form.medalRecord;
      // this.$set(this.form, this.form.administrators, val);
    },
    //  选择是否查看徽章记录
    changeAdministrators(value) {
      this.isDisabled = value == 1 ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    // background-color: #00ada7;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    border-bottom: 4px solid #d0d1d1;
    font-size: 29px;
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
}
</style>
